const GET_DIVISIONS = 'GET_DIVISIONS';
const SET_DIVISIONS = 'SET_DIVISIONS';

export {
    GET_DIVISIONS,
    SET_DIVISIONS
};
